export enum HMSPollType {
  poll,
  quiz,
}
